import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/rules/board_paths_finkel.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/rules/board_paths_masters.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/rules/board_rosettes.png");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbeddedDice"] */ "/app/apps/royalur/src/components/game/dice/EmbeddedDice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/ad/masters-ur-boards.jpg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/ad/MTG-banner.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/ad/societe.jpg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_blitz.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_custom.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_finkel.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_masters.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/play_active.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/play.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/game/example_capture_no_highlight.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/game/example_starting_board.png");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/finkel.jpg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/tournament.jpg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/victor_board.jpg");
